module.exports = __webpack_public_path__ + "static/pic_filmstill_koester_detmold1937_02.6cb0b21f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/project3/pic_filmstill_koester_detmold1937_02.jpg
// module id = 507
// module chunks = 142966368958528